<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!-- <a-form-model-item label="材料分类" prop="materialId">
        <a-select
          show-search
          v-model="form.materialId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item> -->
      <a-form-model-item label="分类名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <!-- <a-form-model-item label="单位" prop="unitVal">
        <a-input v-model="form.unitVal" placeholder="请输入" :maxLength="50" />
      </a-form-model-item> -->
      <a-form-model-item label="类目图标" prop="icon">
        <file-upload
          type="image"
          :defaultList="form.icon"
          :file="form.icon"
          @input="getImg($event, 'icon')"
          :count="1"
          autoCropHeight="200"
          autoCropWidth="200"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="显示图片" prop="pic">
        <file-upload
          type="image"
          :defaultList="form.pic"
          :file="form.pic"
          @input="getImg($event, 'pic')"
          :count="1"
          autoCropHeight="200"
          autoCropWidth="200"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button :value="0"> 禁用 </a-radio-button>
          <a-radio-button :value="1"> 启用 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="角标推荐" prop="subscriptRecommend">
        <a-radio-group v-model="form.subscriptRecommend" button-style="solid">
          <a-radio-button :value="0"> 否 </a-radio-button>
          <a-radio-button :value="1"> 是 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="推荐内容" prop="subscriptRecommendVal" v-if="form.subscriptRecommend">
        <a-input v-model="form.subscriptRecommendVal" placeholder="请输入" :maxLength="30" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入" :maxLength="30" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'

import { getObj, addObj, putObj } from '@/api/repairModule/materialClassification'
import Editor from '@/components/Editor'
export default {
  name: 'CreateForm',
  components: {
    Editor,
  },
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        status: 1,
        sort: 99,
        subscriptRecommend: 0,
        name: undefined,
        pic: undefined,
        icon: undefined,
        subscriptRecommendVal: undefined,
        remark: undefined,
      },
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      rules: {
        icon: [{ required: true, message: '请上传类目分类', trigger: 'blur' }],
        name: [{ required: true, message: '请输入材料名称', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        // unitVal: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        subscriptRecommendVal: [{ required: true, message: '请输入推荐内容', trigger: 'blur' }],
        // unitVal: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        // unitVal: [{ required: true, message: '请输入单位', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    onClose() {
      this.open = false
    },
    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info5555', info)
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        status: 1,
        sort: 99,
        subscriptRecommend: 0,
        name: undefined,
        icon: undefined,
        pic: undefined,
        subscriptRecommendVal: undefined,
        remark: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加材料分类'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改材料分类'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
